import React from 'react';
import { ComponentType } from 'react';

type Props = {
  shouldRender: boolean;
};

function maybe(Component: any): ComponentType<Props> {
  return ({ shouldRender, ...props }: Props | any) =>
    shouldRender ? <Component {...props} /> : null;
}

export default maybe;
